import { Fragment } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SkeletonLoader } from '@frontend/design-system';

export const UsersSkeletonLoader = () => {
  return (
    <div css={containerStyle}>
      <SkeletonLoader height={24} width={24} shape='circle' />
      <SkeletonLoader height={24} width={200} />
    </div>
  );
};

export const UsersSkeletonLoaderList = ({ count = 5 }: { count?: number }) => {
  const arr = new Array(count).fill(0);

  return (
    <Fragment>
      {arr.map((_, index) => (
        <UsersSkeletonLoader key={`users-skeleton-loader${index}`} />
      ))}
    </Fragment>
  );
};

const containerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  padding: ${theme.spacing(1.5, 2)};
`;
